module.exports = __webpack_public_path__ + "img/contention.673bdbec.png";